import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';

import '../../../common/report/reports/Invoice/invoice-table.component.css';

import ButtonIcon from "../../../button";
import { linkedCircuitActions } from "../../../../store/external/inventory-reducer/linked-circuits.reducer";
import { inventoryCircuitActions } from "../../../../store/external/inventory/circuit.reducer";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import Translation from "../../../common/translation/translation.component";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { ROUTE_LINK_LOCATION } from "../../../../constants/external-constants";

class LinkedCircuitComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            displaySearch: false,
            viewDetailPage: false,
            linkCircuitId: 0,
            selectedCircuit: undefined
        }
    }

    componentDidMount() {
        const { getLinkedCircuits, circuitId } = this.props;
        getLinkedCircuits(circuitId);
    }
    componentWillUnmount(){
        this.props.setResetCircuits();
    }
    getLinkedCircuits = (pageIndex) => {
        const { getLinkedCircuits, circuitId } = this.props;
        getLinkedCircuits(circuitId, pageIndex);
    }

    resizePage = (value) => {
        const { circuitId, resizeLinkedCircuits, getLinkedCircuits } = this.props;
        resizeLinkedCircuits(value);
        getLinkedCircuits(circuitId);
    }

    sortLinkedCircuits = (columnName, isSortedAsc) => {
        const { sortLinkedCircuits, circuitId } = this.props;
        sortLinkedCircuits(columnName, isSortedAsc, circuitId);
    }
    displaySearhBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    getData = (isShow, rowItem) => {
        const { getInventoryCircuitDetail } = this.props;

        if (rowItem != null) {
            var circuitId = rowItem.CircuitId;
            var circuitTypeId = rowItem.CircuitTypeID;

            this.setState({
                viewDetailPage: isShow
                , linkCircuitId: circuitId
                , selectedCircuit: rowItem
            })
            this.setState({ viewDetailPage: isShow })
            getInventoryCircuitDetail(circuitId, circuitTypeId);
        }
        else {
            this.setState({ viewDetailPage: isShow })
        }
    }

    navigateToDetails(rowItem) {
        if (rowItem != null) {
            window.open(`${ROUTE_LINK_LOCATION.circuitRouteLink}/${rowItem.CircuitId}`, "_blank")
        }
    }

    render() {
        const { setLinkedCircuitColSearchStr } = this.props;
        const { Headers, Data, Pagination } = this.props.inventoryLinkedCircuit.LinkedCircuitTable;
        const { IsLoadingTable } = this.props.inventoryLinkedCircuit;

        return (
            <div className="details-container">
                <div className="circuit-linked-header-container">
                    <h1><Translation translationKey="list_linked_circuits"/></h1>
                    <ButtonIcon onClick={() => this.displaySearhBox()} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search" />
                </div>
                {
                    IsLoadingTable ?
                        <NoSubscription />
                        :
                        <TablePagination
                            columns={Headers}
                            pageList={Data.Items}
                            pages={Pagination}
                            rowClickAction={(rowItem) => this.navigateToDetails(rowItem)}
                            paginationAction={this.getLinkedCircuits}
                            onColumnClick={this.sortLinkedCircuits}
                            onColumnSearch={() => { this.getLinkedCircuits(0); }}
                            onColumnSearchChange={setLinkedCircuitColSearchStr}
                            isColSearchShow={this.state.displaySearch}
                            resizePage={this.resizePage}
                            totalPage={Pagination.TotalEntries}
                            haveLink={true}
                            tableClassName="table-fit"                   
                            hidePageSizeSelection={true}
                        />
                }
            </div>
        );
    }
}

function LinkedCircuit(props) {
    const history = useHistory();
    return <LinkedCircuitComponent {...props} history={history} />
}

export default connect(
    state => {
        const { inventoryLinkedCircuit } = state;
        return {
            inventoryLinkedCircuit
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, linkedCircuitActions, inventoryCircuitActions),
        dispatch
    )
)(LinkedCircuit);